import { render, staticRenderFns } from "./EditClipboard.vue?vue&type=template&id=df2efa8e&"
import script from "./EditClipboard.vue?vue&type=script&lang=js&"
export * from "./EditClipboard.vue?vue&type=script&lang=js&"
import style0 from "./EditClipboard.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./EditClipboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports